import React, { useEffect, useRef, useState, useCallback } from 'react';
import FilesList from './FilesList';
import styles from './YourFilesContent.module.css';
import backIcon from "../icons/back_icn.png";
import axios from 'axios';

const YourFilesContent = ({ onBack, isAuthenticated, setIsAuthenticated }) => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);
  const [purchasedFiles, setPurchasedFiles] = useState([]);

  const fetchPurchasedFiles = useCallback(() => {
    if (isAuthenticated) {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setPurchasedFiles([]);
        return;
      }

      axios
        .get('/api/purchased/list', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setPurchasedFiles(response.data);
        })
        .catch(() => {
        });
    } else {
      setPurchasedFiles([]);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchPurchasedFiles();

    window.addEventListener('purchasedFilesChanged', fetchPurchasedFiles);

    return () => {
      window.removeEventListener('purchasedFilesChanged', fetchPurchasedFiles);
    };
  }, [isAuthenticated, fetchPurchasedFiles]);

  useEffect(() => {
    const content = contentRef.current;
    if (!content) return;

    const scrollStep = 1;
    const stop = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel',      stop, { passive: true });
      content.removeEventListener('touchstart', stop, { passive: true });
    };

    scrollInterval.current = setInterval(() => {
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        stop();
      } else {
        content.scrollTop += scrollStep;
      }
    }, 50);

    content.addEventListener('wheel',      stop, { passive: true });
    content.addEventListener('touchstart', stop, { passive: true });

    return () => stop();
  }, []);

  const restartAutoScroll = () => {
    const content = contentRef.current;
    if (!content) return;

    clearInterval(scrollInterval.current);
    scrollInterval.current = null;

    const stop = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel',      stop, { passive: true });
      content.removeEventListener('touchstart', stop, { passive: true });
    };

    content.scrollTop = 0;
    const scrollStep = 1;
    scrollInterval.current = setInterval(() => {
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        stop();
      } else {
        content.scrollTop += scrollStep;
      }
    }, 50);

    content.addEventListener('wheel',      stop, { passive: true });
    content.addEventListener('touchstart', stop, { passive: true });
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) { setIsAuthenticated(false); return; }

    axios
      .get('/api/users/verify-token', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        if (r.data.valid) setIsAuthenticated(true);
        else {
          setIsAuthenticated(false);
          localStorage.removeItem('authToken');
          localStorage.removeItem('userId');
        }
      })
      .catch(() => {
        setIsAuthenticated(false);
        localStorage.removeItem('authToken');
        localStorage.removeItem('userId');
      });
  }, [setIsAuthenticated]);

  return (
    <div className={styles.yourFilesContentContainer}>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />
      <h1 className={styles.pageTitle}>Your Files</h1>
      <div className={styles.yourFilesContent} ref={contentRef}>
        {purchasedFiles.length > 0 ? (
          <FilesList
            propBeats={purchasedFiles}
            setPurchasedFiles={setPurchasedFiles}
	    isAuthenticated={isAuthenticated}
            restartAutoScroll={restartAutoScroll}
          />
        ) : (
          <p className={styles.noFilesMessage}>
            {isAuthenticated
              ? 'You haven’t purchased any files yet.'
              : 'Sign In to see your files!'}
          </p>
        )}
      </div>
    </div>
  );
};

export default YourFilesContent;

